<template>
  <Dashboard v-if="item.id" :item="item" type="project">
    <template #header>
      <HeaderComponent :title="$i18n.t('analytics')" :breadcrumb="breadcrumbs" />
    </template>
  </Dashboard>
</template>

<script>
import Dashboard from '@/components/Analytics/Dashboard'
import HeaderComponent from '@/components/Header'
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    id: String,
  },

  watch: {
    id: {
      handler: 'fetch',
      immediate: true,
    },
  },
  computed: {
    ...mapState('Project', ['item', 'promises', 'states']),
    breadcrumbs() {
      return [
        { title: this.$tc('project', 2), action: { name: 'projects' } },
        {
          title: this.item.name,
          action: { name: 'project-dashboard', params: { id: this.id } },
        },
        { title: this.$metaInfo.title },
      ]
    },
  },
  methods: {
    ...mapActions('Project', {
      fetch(dispatch) {
        return dispatch('fetch', [{ id: this.id }])
      },
    }),
  },

  metaInfo() {
    return {
      title: this.$t('analytics'),
    }
  },

  components: {
    Dashboard,
    HeaderComponent,
  },
}
</script>

<style lang="scss"></style>
